import * as React from 'react'
import * as css from './LazyVideo.module.css'
import Video from 'components/common/Video'
import clsx from 'clsx'

export default function LazyVideo({ label, btnClassName, ...props }) {
	const [$clicked, set$clicked] = React.useState(false)

	const ref = React.useRef(null)

	function handleClick() {
		set$clicked(true)
		ref.current?.play()
	}

	return (
		<div className="relative">
			<Video
				ref={ref}
				controls={$clicked}
				playsInline
				preloadPoster
				{...props}
			/>

			{!$clicked && (
				<button
					className={clsx(css.btn, btnClassName)}
					onClick={handleClick}
					title="Play video"
				>
					<span className="action lg">{label || 'Watch video'} ➞</span>
				</button>
			)}
		</div>
	)
}
